import { useTranslation } from 'react-i18next';
import styles from './ErrorPage.module.scss';
import logo from '@cas/assets/wabtec-logo-white.svg';
import { ReactNode } from 'react';

export interface ErrorPageProps {
  title: string;
  message: string;
  details?: string;
  actions?: ReactNode;
  isRootErrorPage?: boolean;
}

export default function ErrorPage({
  title,
  message,
  details,
  actions,
  isRootErrorPage = false,
}: ErrorPageProps) {
  const { t } = useTranslation();

  return (
    <article className={`${styles.errorPage} ${isRootErrorPage && styles['errorPage--root']}`}>
      <div className={styles.container}>
        <header className={styles.header}>
          <img className={styles.logo} src={logo} alt={t('WabtecLogo')} />
        </header>

        <div className={styles.content}>
          <div className={styles.heading}>
            <div className={styles.heading__title}>{title}</div>
            <div className={styles.heading__subhead}>{message}</div>
            {details && <div className={styles.heading__details}>{details}</div>}
          </div>
          {actions && <div className={styles.actions}>{actions}</div>}
        </div>
      </div>
    </article>
  );
}
